import { z } from 'zod'

/**
 * Geführter Rundgang: Stationen in der Reihenfolge, in der K4ia den Besucher
 * durchs Lab führt, mit der Wegbeschreibung von der vorigen Station (bei der
 * ersten: vom Eingang) hierher. Gepflegt im Admin unter „Rundgang“.
 */
export const tourStopSchema = z.object({
  showcaseId: z.string(),
  slug: z.string(),
  title: z.string(),
  shortText: z.string(),
  /** „Dreh dich nach links, lauf zur Glasvitrine …“ — leer heißt: K4ia sagt nur, welcher Stand dran ist. */
  directions: z.string(),
  /** 0-basiert, in Reihenfolge des Rundgangs */
  position: z.number().int(),
})
export type TourStop = z.infer<typeof tourStopSchema>

/** Was das Admin speichert: Reihenfolge und Wegbeschreibungen. */
export const tourInputSchema = z.object({
  stops: z
    .array(
      z.object({
        showcaseId: z.string().min(1),
        directions: z.string().trim().max(1000).default(''),
      }),
    )
    .max(50),
})
export type TourInput = z.infer<typeof tourInputSchema>

/**
 * Phasen eines Rundgang-Zugs: `walk` — K4ia sagt, wohin der Besucher gehen
 * soll; `arrived` — er ist da, K4ia erklärt den Stand; `end` — der Rundgang
 * ist zu Ende.
 */
export const tourPhaseSchema = z.enum(['walk', 'arrived', 'end'])
export type TourPhase = z.infer<typeof tourPhaseSchema>
